//import orderDetail from '../orderDetail/orderDetail.vue';

export default {
  name: 'modal',
  template:'#modal-template',
  props:{
		title: {
			type: String,
			required: true,
			default: () => null
    },
    showFooter: {
			type: Boolean,
			required: false,
			default: () => false
    },
    bodyClass: {
			type: String,
			required: false,
			default: () => null
    },
    modalClass: {
			type: String,
			required: false,
			default: () => null
    },
    headerClass: {
			type: String,
			required: false,
			default: () => null
    },
    contentClass: {
			type: String,
			required: false,
			default: () => null
    },
    resizable: {
			type: Boolean,
			required: false,
			default: () => false
    },
    draggable: {
			type: Boolean,
			required: false,
			default: () => false
    },
  },
  data(){
  		return {
  			footer:true,
        myModalClass:'modal-lg'
  		};
  },
  watch:{
		bodyClass:function(val, oldVal) {
      let _self=this;
      _self.bodyClass=val;
      _self.init();
    },
    modalClass:function(val, oldVal) {
      let _self=this;
      _self.modalClass=val;
      _self.init();
    },
  },
  created(){
    let _self=this;
    _self.init();
  },
  mounted() {
    let _self=this;
    let divCtrl='div.modal-content';
    if(_self.draggable==true){
      _self.applyDraggable(divCtrl);
    }
    if(_self.resizable==true){
      _self.applyResizable(divCtrl);
    }
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        _self.modelClose();
      }
    });
  },
  methods:{
    init(){
      let _self=this;
      _self.myModalClass=_self.modalClass?_self.modalClass:'modal-lg';
  		if(_self.showFooter==="false" || _self.showFooter===false)
      _self.footer=false;
    },
    modelClose(){
      let _self=this;
      _self.$emit('modelClose','modelClose');
     setTimeout(function(){ _self.$emit('close');},700);
    },
    applyDraggable(divCtrl){
      $(divCtrl).draggable({
        cancel: '.modal-body'
      });
    },
    applyResizable(divCtrl){
      $(divCtrl).resizable({
        // only use the eastern handle
        handles: 'e',
        // restrict the width range
        minWidth: 500,
        //maxWidth: 450,
        // resize handler updates the content panel width
        resize: function(event, ui){
          var currentWidth = ui.size.width;
          //console.log('current modal width',currentWidth);
        }
      });
    },
  },
  components:{
  //  orderDetail
  }
}